 <template>

   <!--日历弹窗-->
   <div class="alert-box">
     <span class="mask" @click="closeFun"></span>
     <div class="calendar">
       <div class='tit box'>
         <div class='pre' @click="clickPreMonth()">‹</div>
         <div class='current flex '>{{currentYear}}年{{currentMonth}}月</div>
         <div class='next ' @click='clickNextMonth()'>›</div>
       </div>
       <div class='showData'>
         <div class="week week1">日</div>
         <div class="week">一</div>
         <div class="week">二</div>
         <div class="week">三</div>
         <div class="week">四</div>
         <div class="week">五</div>
         <div class="week week1">六</div>
       </div>
       <div class='showData content'>
         <div v-for="(item,index) in allArr" :key="index" class='itemData' :class="item.month=='current'?'':'dis'" :data-thismonth="item.thismonth" :data-state="item.state>0" :data-currency="item.month" :data-day='item.date' @click='clickNowData' >

           <p class="stock" :class="[index==0?'one':'',index==1?'two':'',index==2?'three':'']" v-if="item.thismonth&&item.state">￥<span>{{item.minprice}}</span>起</p>
           <p class="stock" :class="[index==0?'one':'',index==1?'two':'',index==2?'three':'',item.state>0?'':'gray']" v-if="item.thismonth&&item.state===0">不可约</p>

           <div class="day" :class="[item.state>0?'isMark':'gray',
         currentMonth == nowMonth && nowYear == currentYear && item.date == nowDate && item.month == 'current' ? 'isToday':'',
         currentMonth == selectMonth && currentYear == selectYear && item.date == selectDate && item.month == 'current' ? 'isChoseday' : '']">{{item.date}}</div>

         </div>
       </div>

     </div>
   </div>


</template>

 <script>

   import { mapState, mapMutations } from 'vuex'
   export default {
     data(){
       return{
         selectYear: this.selectTime.selectYear || new Date().getFullYear(),  //选择的日子
         selectMonth: this.selectTime.selectMonth || new Date().getMonth() + 1,
         selectDate:  this.selectTime.selectDate || new Date().getDate(),

         currentYear: this.currentTime.selectYear || new Date().getFullYear(),  //当前日历显示的所在月
         currentMonth: this.currentTime.selectMonth || new Date().getMonth() + 1,
         currentDate: this.currentTime.selectDate || new Date().getDate(),

         nowYear: this.nowTime.year || new Date().getFullYear(), //记录的今天
         nowMonth: this.nowTime.month || new Date().getMonth() + 1,
         nowDate: this.nowTime.day || new Date().getDate(),
         currentMonthDateLen: 0, // 当月天数
         preMonthDateLen: 0, // 当月中，上月多余天数
         nextMonthDateLen: 0, // 当月中，下月多余天数
         allArr: [], //
         nowData: "",
         thismonth: false, //选择的日期是获取的30天的时间
       }
     },
     props:['selectTime','currentTime','nowTime','daysList'],
     mounted: function() {  //在vue初始化时调用

     },
     created(){
       this.getAllArr();
     },
     computed: {

     },
     methods: {
       // 获取某年某月总共多少天
       getDateLen(year, month) {
         let actualMonth = month - 1;
         let timeDistance = +new Date(year, month) - +new Date(year, actualMonth);
         return timeDistance / (1000 * 60 * 60 * 24);
       },
       // 获取某月1号是周几
       getFirstDateWeek(year, month) {
         return new Date(year, month - 1, 1).getDay()
       },

       // 上月 年、月
       preMonth(year, month) {
         if (month == 1) {
           return {
             year: --year,
             month: 12
           }
         } else {
           return {
             year: year,
             month: --month
           }
         }
       },

       // 下月 年、月
       nextMonth(year, month) {
         if (month == 12) {
           return {
             year: ++year,
             month: 1
           }
         } else {
           return {
             year: year,
             month: ++month
           }
         }
       },

       // 获取当月数据，返回数组
       getCurrentArr() {

         let currentMonthDateLen = this.getDateLen(this.currentYear, this.currentMonth); // 获取当月天数
         let currentMonthDateArr = []; // 定义空数组

         let year = this.currentYear;
         let month = (this.currentMonth<10 && String(this.currentMonth).length<=1)  ? '0' + this.currentMonth : this.currentMonth;
         if (currentMonthDateLen > 0) {
           for (let i = 1; i <= currentMonthDateLen; i++) {
             let day = i < 10 ? '0' + i : i;
             currentMonthDateArr.push({
               dateTime: year + '-' + month + '-' + day,
               month: 'current', // 只是为了增加标识，区分上下月
               date: i,
               state: 0
             })
           }

           if (this.daysList) {
             var data = this.daysList;
             for (let i = 0; i < currentMonthDateArr.length; i++) {
               for (let j = 0; j < data.length; j++) {
                 if (currentMonthDateArr[i].dateTime == data[j].time) {
                   currentMonthDateArr[i].state = data[j].minprice>0?1:0;
                   currentMonthDateArr[i].minprice = data[j].minprice;
                   currentMonthDateArr[i].thismonth = true;
                 }
               }
             }
           }
         }
         this.currentMonthDateLen = currentMonthDateLen;
         return currentMonthDateArr
       },

       // 获取当月中，上月多余数据，返回数组
       getPreArr() {
         let preMonthDateLen = this.getFirstDateWeek(this.currentYear, this.currentMonth); // 当月1号是周几 == 上月残余天数）
         let preMonthDateArr = []; // 定义空数组
         if (preMonthDateLen > 0) {
           let { year, month } = this.preMonth(this.currentYear, this.currentMonth); // 获取上月 年、月
           let date = this.getDateLen(year, month); // 获取上月天数
           for (let i = 0; i < preMonthDateLen; i++) {
             preMonthDateArr.unshift({ // 尾部追加
               month: 'pre', // 只是为了增加标识，区分当、下月
               date: date,
               state: 0
             });
             date--
           }
         }
         this.preMonthDateLen = preMonthDateLen;
         return preMonthDateArr
       },

       // 获取当月中，下月多余数据，返回数组
       getNextArr() {
         let nextMonthDateLen = 35 - this.preMonthDateLen - this.currentMonthDateLen; // 下月多余天数
         if (nextMonthDateLen < 0){
           nextMonthDateLen = 7 + nextMonthDateLen
         }
         let nextMonthDateArr = []; // 定义空数组
         if (nextMonthDateLen > 0) {
           for (let i = 1; i <= nextMonthDateLen; i++) {
             nextMonthDateArr.push({
               month: 'next',// 只是为了增加标识，区分当、上月
               date: i,
               state: 0
             })
           }
         }
         return nextMonthDateArr
       },

       // 整合当月所有数据
       getAllArr(type) {
         let preArr = this.getPreArr();
         let currentArr = this.getCurrentArr();
         let nextArr = this.getNextArr();
         let allArr = [...preArr, ...currentArr, ...nextArr]
         this.allArr = allArr;
         let sendObj = {
           selectYear: this.selectYear,
           selectMonth: this.selectMonth,
           selectDate: this.selectDate,

           currentYear: this.currentYear,
           currentMonth: this.currentMonth,
           currentDate: this.currentDate,

           nowYear: this.nowYear,
           nowMonth: this.nowMonth,
           nowDate: this.nowDate,
           allArr: allArr
         };

         if(type == "close"){
           sendObj.calendarShow = 0;
         }

         if(this.thismonth){
           this.$emit('sendObj',sendObj);
         }

       },

       // 点击 上月
       clickPreMonth() {
         this.gotoPreMonth()
       },
       gotoPreMonth(day) {
         let { year, month } = this.preMonth(this.currentYear, this.currentMonth);
         this.currentYear = year;
         this.currentMonth = month;
         this.currentDate = '';

         if (day) {
           this.choseDate(day, 'current')
         } else {
           this.getAllArr();
         }
       },

       // 点击 下月
       clickNextMonth(){
         this.gotoNextMonth()
       },
       gotoNextMonth(day) {
         let { year, month } = this.nextMonth(this.currentYear, this.currentMonth);
         this.currentYear = year;
         this.currentMonth = month;
         this.currentDate = '';

         if (day){
           this.choseDate(day, 'current')
         } else {
           this.getAllArr();
         }
       },

       //点击 选择日子
       clickNowData(e) {
         var data = e.currentTarget.dataset.day;
         var currency = e.currentTarget.dataset.currency;
         var state = e.currentTarget.dataset.state;
         this.thismonth = e.currentTarget.dataset.thismonth;

         if(this.thismonth){
           if(state){
             this.choseDate(data, currency)
           }else {
             this.$toast("所选日期暂无可预约产品");
           }
         }else {
           this.$toast("只能选择近30天内的日期");
         }
       },

       choseDate(data, currency) {
         if (currency == 'current') { //当前月
           this.selectYear = this.currentYear;
           this.selectMonth = this.currentMonth;
           this.selectDate = data;

           this.currentYear = this.currentYear;
           this.currentMonth = this.currentMonth;
           this.currentDate = data;

           this.getAllArr('close')

         } else if (currency == 'pre') { //上月
           this.gotoPreMonth(data);

         } else if (currency == 'next') { //
           this.gotoNextMonth(data);
         }
       },

       //关闭弹窗
       closeFun:function(){
         var sendObj = {};
         sendObj.calendarShow = 0;
         this.$emit('sendObj',sendObj);
       },
     }
   }
 </script>

 <style scoped>
   .alert-box{position: fixed;top:0;left: 0;z-index:10;width: 100vw;height: 100vh;}
   .alert-box .close{position: absolute;top:.4rem;right: .4rem;width: auto;height: .28rem;}
   .alert-box .mask{position: absolute;left: 0;top:0;width: 100%;height: 100%;background: rgba(0,0,0,.6);}

   .calendar { position: relative;z-index: 1; width: 100%; background: #fff; padding-bottom: .5rem; }
   .calendar .tit { position: relative; width: 100%; display: -webkit-box; display: box; justify-content: center; align-items: center; padding: .40rem 0; }
   .current { -webkit-box-flex: 1; box-flex: 1; font-size: .32rem; color: #333; text-align: center; }
   .pre, .next { font-size: .3rem; color: #999; background: #e8e8e8; border-radius: 1rem; height: .4rem; width: .4rem; text-align: center; line-height: .4rem; }
   .pre { margin-left: 5%; }
   .next { margin-right: 5%; }
   .showData { display: flex; justify-content: center; align-items: center; box-sizing: border-box; flex-wrap: wrap; }
   .showData > div { width: 14%; height: 1rem; text-align: center; flex-shrink: 0; }
   .showData .week { height: .9rem; font-size: .28rem; color: #333; }
   .showData .week1 { color: #999; }
   .content .itemData { position: relative; font-size: .24rem; font-weight: 600; color: #222; display: flex; /*align-items: center;*/ justify-content: center; }
   .content .itemData .stock { position: absolute; left: 0; right: 0; bottom: .05rem; z-index: 1; font-size: .2rem; font-weight: normal; text-align: center; color: #ff9e05; }
   .content .itemData .stock span{ font-size: .24rem; }
   .content .itemData .gray { color: #ccc; font-weight: normal;}
   .content .dis .gray { color: transparent;}
   .content .dis{pointer-events: none;}
   .content .itemData .day { position: relative; height: .64rem; width:  .64rem; line-height:  .64rem; }
   .content .itemData .isToday:before { position: absolute; left: 0; top: 0; width: 100%; height: 100%; line-height: .64rem; border-radius: 50%; content: "\4ECA\5929" !important;font-size: .24rem; color: #ff9e05 !important; background-color: #fff !important; }
   .content .itemData .isToday.isChoseday:before { color: #fff !important; background: -webkit-gradient(linear, left top, right top, from(#ff7d34), to(#ffb54d)) !important; background: linear-gradient(90deg, #ff7d34, #ffb54d) !important; }
   .content .itemData .isChoseday { border-radius: 50%; color: #fff !important; background: -webkit-gradient(linear, left top, right top, from(#ff7d34), to(#ffb54d)) !important; background: linear-gradient(90deg, #ff7d34, #ffb54d) !important; }


 </style>



// WEBPACK FOOTER //
// src/components/calendar.vue